module.exports = __webpack_public_path__ + "img/clock-transparrent.11ce167b.svg";